import * as get from 'lodash/get';
import * as isArray from 'lodash/isArray';

import { SeriesMapper } from './series-mapper.interface';

export class LodashSeriesMapper implements SeriesMapper {
	constructor(public readonly storeDependencies: string[], public readonly expression: string) { }
	public getStoreDependencies(): string[] {
		return this.storeDependencies;
	}
	public mapper(...storeData: any[]): any[] {
		const lookup = {};
		for (let i = 0; i < storeData.length; i++) {
			lookup[this.storeDependencies[i]] = storeData[i];
		}
		const result = get(lookup, this.expression, []);
		return isArray(result) ? result : [result];
	}
}
